import { ReactElement, useEffect } from 'react';

import { useApiMutation } from '~/hooks/api';
import { useStoreActions, useStoreState } from '~/store/hooks';

import TestAiRequestForm from '../TestAiRequestForm';

import { IAiSettings } from '~/services/api/ai/types';
import { IAiTestRequestFormValues } from '../../types';

const TestAiRequest = ({ aiSettings }: { aiSettings: IAiSettings }): ReactElement => {
  const { onSendAiRequest, setAiTestResponse } = useStoreActions(actions => actions.ai);
  const { testAiResponse } = useStoreState(store => store.ai);

  const { mutate: sendTestRequest, isLoading } = useApiMutation(
    (values: IAiTestRequestFormValues) => onSendAiRequest({ ...values, ...aiSettings }),
  );

  useEffect(
    () => () => {
      setAiTestResponse(null);
    },
    [setAiTestResponse],
  );

  return (
    <TestAiRequestForm
      testAiResponse={testAiResponse}
      title="Send Test AI Request"
      onSubmit={sendTestRequest}
      loading={isLoading}
    />
  );
};

export default TestAiRequest;
